export const ROUTE_PATHS = {
  PROJECTS: 'projects',
  PROJECT_DETAILS: 'details/:project_id',
  DASHBOARD_REPORTING: 'dashboard/reporting/list',
  INSIGHT: 'insight'
} as const;